var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5398 0C4.76274 0 0.0795898 4.68315 0.0795898 10.4602C0.0795898 16.2372 4.76274 20.9204 10.5398 20.9204C16.3168 20.9204 21 16.2372 21 10.4602C21 4.68315 16.3167 0 10.5398 0ZM7.74899 15.5172H5.45234V8.09743H7.74899V15.5172ZM6.58972 7.12575C5.83966 7.12575 5.23161 6.51274 5.23161 5.75667C5.23161 5.00052 5.83975 4.38755 6.58972 4.38755C7.3397 4.38755 7.94775 5.00052 7.94775 5.75667C7.94779 6.51278 7.33974 7.12575 6.58972 7.12575ZM16.3557 15.5172H14.0701V11.6224C14.0701 10.5542 13.6644 9.95793 12.8197 9.95793C11.9004 9.95793 11.4202 10.579 11.4202 11.6224V15.5172H9.21743V8.09743H11.4202V9.09675C11.4202 9.09675 12.0828 7.8711 13.6561 7.8711C15.2294 7.8711 16.3557 8.83177 16.3557 10.8191L16.3557 15.5172Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).14dd9fa8401d9989160a1b06a86c0aca.svg";
export { ForwardRef as ReactComponent };